import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TabelaMedida } from '../interfaces/tabela-medida';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { UnMedida } from '../interfaces/un-medida';

@Injectable({
  providedIn: 'root'
})
export class TabelaMedidaService {

  readonly url = `${environment.apiURL}/cadastro/tabela/medida`;

  constructor(private http: HttpClient) { }

  saveOrUpdate(cadastro: TabelaMedida): Observable<TabelaMedida> {
    return this.http.put<TabelaMedida>(`${this.url}`, cadastro);
  }

  getItem(id: number ): Observable<TabelaMedida> {
    return this.http.get<TabelaMedida>(`${this.url}/${id}`);
  }

  getItemPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<TabelaMedida>> {
    return this.http.get<PageResult<TabelaMedida>>(`${this.url}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getItemPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<TabelaMedida>> {
    return this.http.get<PageResult<TabelaMedida>>(`${this.url}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }
}
